import BaseService from "../BaseService";
import http from "../HttpService";
import { API_BASE_URL_ENV } from "helpers/common";

const apiEndpoint = API_BASE_URL_ENV() + "/admin/user/clients";
const apiClientsEndPoint = API_BASE_URL_ENV() + "/admin/user/clients"
// const exportApi =API_BASE_URL_ENV() + "/admin/user/clients?export=1"
const exportApi =API_BASE_URL_ENV() + "/admin/user/clients"

export default class extends BaseService {
    constructor() {
        super(apiEndpoint);
    }

    getClients= () =>{
      return http.get(apiClientsEndPoint)
    }
    
    toggleStatus=(id)=>{ 
        return   http.get(`${API_BASE_URL_ENV()}/admin/user/toggle-activation/Client/${id}`)   
       }

    getExportUrl = (active,searchWord) => {
        const obj = JSON.parse(localStorage.getItem("auth"))
        let url = `${exportApi}&token=${obj.access_token}`;
        if (active != 'all')  url =url + `&status=${active === "active" ? 1 : 0}`;
        if (searchWord.trim().length)  url =url + `&keyword=${searchWord}`;
        return url
    }

    updateClient= (data, id) => {
        const url = API_BASE_URL_ENV() + `/admin/user/clients/${id}`
        return http.put(url, data)
    }

    deleteClient= (id) => {
        return http.delete(`${API_BASE_URL_ENV()}/admin/user/clients/${id}`)
    }

}